<template>
	<div class="display-flex flex-column width-100 height-100 menu-container">
		<div class="menu-container flex-centerize">
			<div
				:key="backgroundImage"
				v-for="backgroundImage in BACKGROUND_IMAGES"
				class="invisible-item-container flex-centerize"
				@click="$emit('change-background-image', backgroundImage)"
				:class="{ 'is-selected': backgroundImage === backgroundImageSrc }"
			>
				<FeatureBackgroundImage class="item-container" :name="backgroundImage" />
			</div>
		</div>
		<FeatureBackgroundFileUpload />
	</div>
</template>

<script>
import { isBackgroundColor } from '@/utils/helpers.js';
import FeatureBackgroundImage from '@/components/BlockEditorWidget/FieldSettings/PageOptions/FeatureBackgroundImage';
import FeatureBackgroundFileUpload from '@/components/BlockEditorWidget/FieldSettings/PageOptions/FeatureBackgroundFileUpload';
import { BACKGROUND_IMAGES } from '@/utils/workflow-service.const';
export default {
	name: 'FeatureBackgroundImageSelectionMenu',
	props: { backgroundImageSrc: { type: String } },
	components: { FeatureBackgroundImage, FeatureBackgroundFileUpload },
	data() {
		return {
			BACKGROUND_IMAGES,
		};
	},
	methods: {
		initializeImages() {
			if (
				this.backgroundImageSrc &&
				!isBackgroundColor(this.backgroundImageSrc) &&
				!this.BACKGROUND_IMAGES.includes(this.backgroundImageSrc)
			) {
				this.BACKGROUND_IMAGES = [this.backgroundImageSrc, ...this.BACKGROUND_IMAGES];
			}
		},
	},
	mounted() {
		this.initializeImages();
	},
	watch: {
		backgroundImageSrc() {
			this.initializeImages;
		},
	},
};
</script>
<style scoped lang="scss">
.invisible-item-container {
	padding: 10px;
	border-radius: 10px;

	&.is-selected {
		border: 1px solid #5b8df6;
		box-shadow: 0px 1px 2px #0000002e;
	}
}
.item-container {
	width: 120px;
	height: 80px;
	cursor: pointer;
	border-radius: 10px;
}

.menu-container {
	display: flex;
	flex-wrap: wrap;
}
</style>
